import { buildCompanyMenuUrl } from 'src/utils/data/company-statuses';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import TablePageRoute from './pages/TablePage';
import MainLayout from './MainLayout';
import CompanyPageRoute from './pages/CompanyPage';
import AuthPageRoute from './pages/AuthPage';
import DefaultTableCBids from 'src/components/ui/DefaultTable/connectors/DefaultTableCBids';
import { getAllWorthsLoader } from './loaders/getWorthsLoader';
import DefaultTableCWorth from 'src/components/ui/DefaultTable/connectors/DefaultTableCWorth';
import DefaultTableCObjections from 'src/components/ui/DefaultTable/connectors/DefaultTableCObjections';
import { getCallsLoader } from './loaders/getCallsLoader';
import DefaultTableCCalls from 'src/components/ui/DefaultTable/connectors/DefaultTableCCalls';
import { getObjectionsLoader } from './loaders/getObjectionsLoader';
import { getCompaniesLoader } from './loaders/getCompaniesLoader';
import { getCompanyLoader } from './loaders/getCompanyLoader';
import { noAccessLoader } from './loaders/noAccessLoader';
import { requireAuthLoader } from './loaders/requireAuthLoader';
import ErrorBoundary from './ErrorBoundary';

const DEFAULT_COMMISSION_URL = buildCompanyMenuUrl('commission', 'inwork');

const companies = [
	{
		id: `commission`,
		path: `commission`,
		element: <TablePageRoute type={'bids'} Component={DefaultTableCBids} />,
		loader: (args) => getCompaniesLoader(args, { salesTarget: 'COMMISSION' }),
	},
	{
		id: `abonent`,
		path: `abonent`,
		element: <TablePageRoute type={'bids'} Component={DefaultTableCBids} />,
		loader: (args) => getCompaniesLoader(args, { salesTarget: 'ABONENT' }),
	},
	{
		id: `account-management`,
		path: `account-management`,
		element: <TablePageRoute type={'bids'} Component={DefaultTableCBids} />,
		loader: (args) =>
			getCompaniesLoader(args, { isAccountManagement: true }),
	},
	{
		id: `content-management`,
		path: `content-management`,
		element: <TablePageRoute type={'bids'} Component={DefaultTableCBids} />,
		loader: (args) =>
			getCompaniesLoader(args, { isContentManagement: true }),
	},
];

const calls = [
	{
		id: `calls`,
		path: `calls`,
		element: (
			<TablePageRoute
				type={'calls'}
				status={'all'}
				Component={DefaultTableCCalls}
			/>
		),
		loader: getCallsLoader,
	},
];

const objections = [
	{
		id: `objection`,
		path: `objection`,
		element: (
			<TablePageRoute
				type={'objections'}
				status={'all'}
				Component={DefaultTableCObjections}
			/>
		),
		loader: getObjectionsLoader,
	},
];

const worths = [
	{
		id: 'worth',
		path: `worth`,
		element: (
			<TablePageRoute type={'worths'} Component={DefaultTableCWorth} />
		),
		loader: getAllWorthsLoader,
	},
];

export const router = createBrowserRouter([
	{
		path: '/',
		element: <MainLayout />,
		loader: requireAuthLoader,
		errorElement: <ErrorBoundary />,
		children: [
			{
				index: true,
				element: <Navigate to={DEFAULT_COMMISSION_URL} replace />,
			},

			...companies,
			...calls,
			...objections,
			...worths,

			{
				id: 'company',
				path: 'company/:companyId',
				loader: getCompanyLoader,
				element: <CompanyPageRoute />,
			},
		],
	},
	{
		path: 'no-access',
		element: <AuthPageRoute />,
		loader: noAccessLoader,
		errorElement: <ErrorBoundary />,
	},
]);
